import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

interface DialogConfirmationProps extends Omit<DialogProps, 'children'> {
  isLoading?: boolean
  ctaConfirm?: string
  onClickConfirm?: () => any
  ctaCancel?: string
  onClickCancel?: () => any
  title: string
  description: string
  btnFullWidth?: boolean
}

export function DialogConfirmation({
  isLoading,
  onClickConfirm = () => {},
  onClickCancel = () => {},
  title,
  description,
  ctaConfirm = 'Simpan dan keluar',
  ctaCancel = 'Kembali',
  btnFullWidth = false,
  ...props
}: DialogConfirmationProps) {
  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent title={title}>
        <div className="p-6">
          <Text variant="display-sm">{title}</Text>
          <Text variant="body-lg" color="subdued" className="mt-3">
            {description}
          </Text>

          <div className="flex gap-3 mt-3">
            <Button
              size="lg"
              color="white"
              disabled={isLoading}
              isLoading={isLoading}
              onClick={() => onClickCancel()}
              data-testid="btn-cancel"
              fullWidth={btnFullWidth}
            >
              {ctaCancel}
            </Button>
            <Button
              size="lg"
              disabled={isLoading}
              isLoading={isLoading}
              onClick={() => onClickConfirm()}
              data-testid="btn-confirm"
              fullWidth={btnFullWidth}
            >
              {ctaConfirm}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogConfirmation
